module.exports = __webpack_public_path__ + "img/232.1b703da2.png";